module.exports = __webpack_public_path__ + "static/media/intro.6e551049.mp3";